import { Spin } from "antd";
import { Navigate } from "react-router-dom";
import { useToken } from 'utils/utility';
import styled from "styled-components";
import { INDEX_PATH, SIGN_IN_PATH } from "utils/routes";

const Protected = ({ children }) => {
  const { token, success, loading } = useToken();

  if (loading || !success)
    return <StyledSpin />

  if (!token) {
    return <Navigate to={SIGN_IN_PATH} replace />;
  }

  return children;
};

const Guest = ({ children }) => {
  const { token, success, loading } = useToken();

  if (loading || !success)
    return <StyledSpin />;

  if (token)
    return <Navigate to={INDEX_PATH} replace />;

  return children;
};

export { Protected, Guest };

const StyledSpin = styled(Spin)`
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
